/* eslint-disable no-return-assign */
import FormRow from './FormRow'
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl'
import InputNumber from '../../forms/InputNumber'

const msg = defineMessages({
  placeholderTextarea: {
    id: 'placeholder.textarea',
    defaultMessage: 'Please tell us what you are looking for and when would be a good time to reach you?',
  },
})

function WhatAreYouLooking({ intl, errors, onChange, isDiving, isAccommodationAndDiving, isLiveaboardTrip, numberDivers, numberGuests, numberDivesPerDiver, description, numberRooms }) {
  return <FormRow title={<FormattedMessage id='looking_for' defaultMessage='What are you looking for?' />}>
    <div className='checkbox-container'>
      <div className='checkbox-wrap'>
        <label className='checkbox-wrap'>
          <input type='checkbox'
            onChange={(e) => {
              onChange('is_diving', e.target.checked)
              onChange('is_accommodation_and_diving', false)
            }}
            checked={isDiving} />
          <span />
          <strong>
            <FormattedMessage id='diving_only' defaultMessage='Diving only' />
          </strong>
        </label>
      </div>
      <div className='checkbox-wrap'>
        <label className='checkbox-wrap'>
          <input type='checkbox'
            onChange={(e) => {
              onChange('is_accommodation_and_diving', e.target.checked)
              onChange('is_diving', false)
            }
            }
            checked={isAccommodationAndDiving} />
          <span />
          <strong>
            <FormattedMessage id='room_and_diving' defaultMessage='Room & diving' />
          </strong>
        </label>
      </div>
      <div className='checkbox-wrap'>
        <label className='checkbox-wrap'>
          <input type='checkbox'
            onChange={(e) => onChange('is_liveaboard_trip', e.target.checked)}
            checked={isLiveaboardTrip} />
          <span />
          <strong>
            <FormattedMessage id='liveaboard_trip' defaultMessage='Liveaboard trip' />
          </strong>
        </label>
      </div>
    </div>
    <div className='plus-minus-container'>
      <label className={`plus-minus ${errors.number_divers ? 'error-field' : ''}`}>
        <strong>
          <FormattedMessage id='number_of_divers' defaultMessage='Number of divers' />
          <i className='asterisk'>*</i>
        </strong>
        <InputNumber name='numberOfDivers' minNumber={0} plusMinus onChange={(val) => onChange('number_divers', val)} isRequired value={numberDivers} />
      </label>
      <label className='plus-minus'>
        <strong>
          <FormattedMessage id='number_of_non_divers' defaultMessage='Number of non-divers' />
        </strong>
        <InputNumber name='numberOfGuests' minNumber={0} plusMinus onChange={(val) => onChange('number_guests', val)} isRequired value={numberGuests} />
      </label>
    </div>
    {/* { !isLiveaboardTrip ? (
      (<div>
        <label className='plus-minus'>
          <strong>
            <FormattedMessage id='number_of_dives_per_diver_per_trip' defaultMessage='Number of dives / per diver / for the trip' />
          </strong>
          <InputNumber name='numberDivesPerDiver' minNumber={0} plusMinus onChange={(val) => onChange('number_dives_per_diver', val)} isRequired value={numberDivesPerDiver} />
        </label>
      </div>)
    ) : '' } */}
    { !isDiving ? (
      <div>
        <label className='plus-minus'>
          <strong>
            <FormattedMessage id='number_of_rooms_cabins' defaultMessage='Number of rooms/cabins' />
          </strong>
          <InputNumber name='numberRooms' minNumber={0} plusMinus onChange={(val) => onChange('number_rooms', val)} isRequired value={numberRooms} />
        </label>
      </div>
    ) : '' }
    <div>
      <textarea
        className='textarea'
        value={description}
        onChange={(e) => onChange('description', e.target.value)}
        placeholder={intl.formatMessage(msg.placeholderTextarea)} />
    </div>
  </FormRow>
}

WhatAreYouLooking.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(WhatAreYouLooking)
